import { getContentLikeTitle } from "../notificationTitles.service";

export interface IContentLikeTitle {
    user: string;
    contentAuthor?: string,
    isPopOut?: boolean
}

const ContentLikeTitle = ({user, contentAuthor, isPopOut}: IContentLikeTitle ) => {
    const {className, activityInformation} = getContentLikeTitle({user, contentAuthor, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation}
        </span>
    );
};
export default ContentLikeTitle;